import './utils/fontawesome-icons.js'
import './components/jigsai-app.js'
import './utils/theme-manager.js'

// Initialize theme on page load
document.addEventListener('DOMContentLoaded', () => {
    // Initialize theme based on system preference
    const themeManager = window.themeManager
    if (themeManager) {
        themeManager.initializeTheme()
    }
})

// Handle system theme changes - always follow system preference
if (window.matchMedia) {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    mediaQuery.addEventListener('change', (e) => {
        const themeManager = window.themeManager
        if (themeManager) {
            themeManager.setTheme(e.matches ? 'dark' : 'light')
        }
    })
}